import { render, staticRenderFns } from "./wUploadAjax.vue?vue&type=template&id=501798aa&scoped=true&"
import script from "./wUploadAjax.vue?vue&type=script&lang=js&"
export * from "./wUploadAjax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501798aa",
  null
  
)

export default component.exports